import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WORKINGTIME, WORKINGTIMEALL } from '../../services/actions';
import { Button, Box, Typography, Container, Paper, Grid, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import RFG from '../../libs/inputs/RFG';
import ActionBar from '../extra/ActionBar';
import { FormHeroHeader, FormSectionCard, FormFooter, labelStyle } from '../extra/FormLayout';
import { BsClockFill } from 'react-icons/bs';

export default function WorkingTimeSettings() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const workingTimeAllState = useSelector(state => state.workingtimeallState);
    const results = Array.isArray(workingTimeAllState?.data) ? workingTimeAllState.data : (workingTimeAllState?.data?.results || []);
    const setting = results[0]; // Assume single setting instance
    
    const { handleSubmit, control, reset } = useForm({
        defaultValues: { start_time: '09:00', end_time: '18:00', tolerance_minutes: 15, first_half_cutoff: '13:30' },
        mode: "all"
    });

    useEffect(() => {
        dispatch({ type: `${WORKINGTIMEALL}_GET`, payload: "attendance/settings/" });
    }, [dispatch]);

    useEffect(() => {
        if (setting) {
            reset({
                start_time: setting.start_time || '09:00',
                end_time: setting.end_time || '18:00',
                tolerance_minutes: setting.tolerance_minutes || 15,
                first_half_cutoff: setting.first_half_cutoff || '13:30'
            });
        }
    }, [setting, reset]);

    const onSubmit = (data) => {
        const callback = (resp) => {
            if (!resp?.error) {
                Swal.fire({
                    title: 'Settings Saved!',
                    text: 'Working time schedule and tolerances updated successfully.',
                    icon: 'success',
                    timer: 2500,
                    showConfirmButton: false
                });
            }
            dispatch({ type: `${WORKINGTIMEALL}_GET`, payload: "attendance/settings/" });
        };

        if (setting) {
            dispatch({ type: `${WORKINGTIME}_PATCH`, payload: { id: setting.id, ...data }, callback });
        } else {
            dispatch({ type: `${WORKINGTIME}_POST`, payload: data, callback });
        }
    };

    return (
        <Container maxWidth="false" className="py-3">
            <ActionBar
                showGrid={[]}
                btnImport=""
                label="Working Time Settings"
                setOpen={() => {}}
                hasPermission={false}
                btnLabel=""
            />
            <Box sx={{ py: 3, px: { xs: 1, md: 3 }, maxWidth: '1400px', mx: 'auto' }}>
                <FormHeroHeader
                    icon={<BsClockFill size={26} />}
                    title="Configure Default Work Hours"
                    subtitle="Set standard daily working hours, late arrival tolerance, and half-day cutoff times."
                    badgeText="Attendance Settings"
                />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormSectionCard
                        icon={<BsClockFill size={20} />}
                        title="Work Schedule & Tolerances"
                        subtitle="Specify standard shift times and grace periods in minutes"
                    >
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Stack spacing={2.5}>
                                    <RFG name="start_time" label="Start Time *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                        <input type="time" autoComplete="false" />
                                    </RFG>
                                    <RFG name="end_time" label="End Time *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                        <input type="time" autoComplete="false" />
                                    </RFG>
                                </Stack>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Stack spacing={2.5}>
                                    <RFG name="tolerance_minutes" label="Tolerance (minutes) *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                        <input type="number" autoComplete="false" placeholder="e.g. 15" />
                                    </RFG>
                                    <RFG name="first_half_cutoff" label="First Half Cutoff Time *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                        <input type="time" autoComplete="false" />
                                    </RFG>
                                </Stack>
                            </Grid>
                        </Grid>
                    </FormSectionCard>
                    <FormFooter onCancel={() => navigate(-1)} backText="Cancel" submitText="Save Settings" backTestId="back-settings-btn" saveTestId="save-settings-btn" />
                </form>
            </Box>
        </Container>
    );
}
